import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import CircularProgressbar from "react-circular-progressbar";
import { isMobile } from "../../utils/util";

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// import './Product.css';

class RecommendationsProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addedToCart: false,
      productCart: props.productCart
    };
  }

  componentDidMount() {
    const isNotFirstTime = localStorage.getItem("recohaspurchased");
    const localCart = localStorage.getItem(
      "recommendations_cart_fetched_with_prod"
    );
    // this.generateRecReason();
    if (this.props.isFirstTime && this.props.index === 0) {
      this.setState({ addedToCart: true });
    } else {
      if (
        /*(localCart && JSON.parse(localCart).some(product => product.id === this.props.product.id)) ||*/
        this.state.productCart &&
        this.state.productCart.some(
          product => product.id === this.props.product.id
        )
      ) {
        this.setState({ addedToCart: true });
      } else {
        this.setState({ addedToCart: false });
      }
    }

    //Mark as Added if On Orders Page
    if (
      window.location.pathname.includes("/orders") &&
      localStorage.getItem(`order-quickadd-product-${this.props.product.id}`)
    ) {
      this.setState({ addedToCart: true }, () => {
        // this.props.syncProductsForOrderPageFromQuickAdd(this.props.product);
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.productsArrFromOrderPage !== this.props.productsArrFromOrderPage
    ) {
      var productIdS = []
      this.props.productsArrFromOrderPage.forEach(element => {
        productIdS.push(element.id)
      });
      if (productIdS.includes(this.props.product.id)){
        this.setState({ addedToCart: true });
      }else {
        this.setState({ addedToCart: false });
      }
    }
  }

  addToCartLabel = e => {
    e.preventDefault();
    e.stopPropagation();
    
    if(this.props.product.inventory <= 0){
      alert('Out of stock');
      return false
    }else{
      let addedToCart = !this.state.addedToCart;
      this.setState({ addedToCart: addedToCart }, () => {
        //Handle Adds on Order Page
        // if (window.location.pathname.includes("/orders")) {
        //   if (this.state.addedToCart) {
        //     console.log("Added to local");
        //     localStorage.setItem(
        //       `order-quickadd-product-${this.props.product.id}`,
        //       JSON.stringify(this.props.product)
        //     );
        //   } else {
        //     console.log("Removed from local");
        //     localStorage.removeItem(
        //       `order-quickadd-product-${this.props.product.id}`
        //     );
        //   }
        //   this.props.syncProductsForOrderPageFromQuickAdd(this.props.product);
        // } else {

          this.props.saveCartForLater(this.props.product);
            this.props.recalculate();
        // }
      });
    }
  };

  render() {
    if (this.props.product) {
      return (
        <div className="products-add-item">
          <a className="products-add-item-like-a" target={ isMobile(navigator.userAgent) ? "_self" : "_blank" } href={`/recommendations/products/${this.props.product.id}`}>
            <div className="products-add-item-image">
              <img alt="" className="lazyload" data-src={this.props.product.coverImageSource} />
            </div>
            <div className="products-add-item-name-price">
              <div className="products-add-item-name-title">
                {this.props.product.vendor}
              </div>
              <div
                className="products-add-item-name"
                title={this.props.product.name}
              >
                {this.props.product.name}
              </div>
              
            </div>
            <div className="products-add-item-button">
              <div className="products-add-item-price">${this.props.product.price} </div>
              <button
                className={
                  !this.state.addedToCart
                    ? "cart-button"
                    : "cart-button addedButton"
                }
                onClick={this.addToCartLabel}
              >
                {!this.state.addedToCart ? "Add" : "Added"}
              </button>
            </div>
          </a>
        </div>
      );
    } else {
      return <div className="product" style={{ visibility: "hidden" }} />;
    }
  }
}

export default RecommendationsProduct;



// WEBPACK FOOTER //
// ./src/views/recommendations/RecommendationsProduct.js